import React from "react";
import { BarChart2, ChevronRight, X, ArrowLeft } from "lucide-react";
import { DateRange } from "../types/PerformanceTypes";
import PeriodSelector  from "./PeriodSelector";
import CompareBtn      from "./CompareBtn";
import ExportButton    from "../ui/Exportbutton";

// Re-exports pour compatibilité avec les imports existants
export { shiftRangeBack, formatDateLabel } from "../utils/headerUtils";
export { default as CompareRangeRow }      from "./CompareRangeRow";

interface GBPHeaderProps {
  ficheName?:      string;
  locationName?:   string;
  hasLocation:     boolean;
  dateRange:       DateRange;
  activePeriod:    number | null;
  compareEnabled:  boolean;
  exporting:       boolean;
  dataReady:       boolean;
  onDateChange:    (r: DateRange) => void;
  onQuickRange:    (days: number) => void;
  onToggleCompare: () => void;
  onExportCSV:     () => void;
  onExportReport:  () => void;
  onClose?:        () => void;
  onNavigateHome?: () => void;
}

const GBPHeader: React.FC<GBPHeaderProps> = ({
  ficheName, locationName, hasLocation,
  dateRange, activePeriod, compareEnabled,
  exporting, dataReady,
  onDateChange, onQuickRange, onToggleCompare,
  onExportCSV, onExportReport,
  onClose, onNavigateHome,
}) => (
  <div className="flex flex-wrap items-center gap-3 px-4 sm:px-6 py-4
    bg-white border-b border-slate-100">

    {/* Title */}
    <div className="flex items-center gap-3 min-w-0 flex-1">
      <div className="w-9 h-9 rounded-[9px] flex items-center justify-center
        bg-gradient-to-br from-[#0F52BA] to-blue-400 flex-shrink-0 shadow-sm shadow-blue-200">
        <BarChart2 size={18} color="#fff" />
      </div>
      <div className="min-w-0">
        <h2 className="text-[15px] font-bold text-slate-900 truncate">
          Performance GBP
        </h2>
        {hasLocation && (
          <div className="flex items-center gap-1 mt-0.5 min-w-0">
            <ChevronRight size={12} color="#cbd5e1" />
            <p className="text-xs text-slate-500 truncate">
              {ficheName || locationName}
            </p>
          </div>
        )}
      </div>
    </div>

    {/* Controls */}
    {hasLocation && (
      <div className="flex flex-wrap items-center gap-2 w-full lg:w-auto">
        <PeriodSelector
          dateRange={dateRange}
          activePeriod={activePeriod}
          onQuickRange={onQuickRange}
          onDateChange={onDateChange}
        />
        <div className="hidden sm:block w-px h-5 bg-slate-200" />
        <CompareBtn enabled={compareEnabled} onToggle={onToggleCompare} />
      </div>
    )}

    {/* Export */}
    {hasLocation && dataReady && (
      <div className="flex items-center gap-2 w-full sm:w-auto">
        <div className="hidden sm:block w-px h-5 bg-slate-200" />
        <ExportButton
          exporting={exporting}
          onExportCSV={onExportCSV}
          onExportReport={onExportReport}
          compareEnabled={compareEnabled}
        />
      </div>
    )}

    {/* Close / Back */}
    <div className="ml-auto flex-shrink-0">
      {onClose ? (
        <button
          onClick={onClose}
          className="w-8 h-8 flex items-center justify-center rounded-lg
            border border-slate-100 bg-white text-slate-400
            hover:bg-slate-50 hover:text-slate-700 transition-colors"
        >
          <X size={15} />
        </button>
      ) : onNavigateHome ? (
        <button
          onClick={onNavigateHome}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg
            border border-slate-100 bg-white text-slate-500 text-xs font-medium
            hover:border-slate-200 hover:text-slate-700 transition-colors"
        >
          <ArrowLeft size={13} /> Retour
        </button>
      ) : null}
    </div>
  </div>
);

export default GBPHeader;